import React, { FC, useMemo, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { keyBy, find, orderBy, each } from '@dt/fe-utils/dist/lodash'
import { storeMobx } from '@mobxStore'
import { modalLayer } from '@utils'
import StoreListModal from '../StoreListModal'
import './index.scss'

interface IProps {
  scene: 'cardRenew' | 'cardRecharge' | 'giftCard' | 'groupBuy';
  openChoose: boolean;
  detailInfo: {
    isAllStore: boolean;
    storeIds?: number[];
  };
  storeInfo: IStoreInfo;
  onChange: (info: IStoreInfo) => void;
}

const ChooseStore: FC<IProps> = (props: IProps) => {
  const {
    openChoose,
    scene,
    storeInfo,
    detailInfo,
    onChange
  } = props
  const chooseStore = () => {
    if (storeList.length <= 1) return
    modalLayer(StoreListModal, { storeList }, 'StoreListModal').then((val: any) => {
      onChange({ storeId: val.storeId, storeName: val.storeName })
    }).catch(() => { })
  }
  const handleAllStore = (storeIds: number[]) => {
    const list = []
    each(storeIds, (i: number) => {
      const findItem = find(storeMobx.viewStoreList, (item: any) => item.storeId === i)
      if (findItem) list.push(findItem)
    })
    return orderBy(list, 'distance') || []
  }
  const handleBuyMost = (store: any[]) => {
    const list = []
    each(storeMobx.storeBoughtList, (i: any) => {
      const findItem = find(store, (item: any) => item.storeId === parseFloat(i.storeId))
      if (findItem) list.push(i)
    })
    return orderBy(list, 'cnt', 'desc') || []
  }
  const storeList: IViewStore[] = useMemo(() => {
    const showList = detailInfo.isAllStore ? orderBy(storeMobx.viewStoreList, 'distance') : handleAllStore(detailInfo.storeIds)
    if (showList.length) showList[0].isNearly = true
    const boughtList: any[] = handleBuyMost(showList)
    if (!boughtList.length) return showList
    const moreList = []
    const _boughtObj = keyBy(boughtList, 'storeId')
    showList.forEach(item => {
      const _item = _boughtObj[item.storeId]
      if (item.storeId === parseFloat(boughtList[0].storeId)) {
        moreList.unshift({
          ...item,
          boughtCnt: _item?.cnt || 0
        })
      } else {
        moreList.push({
          ...item,
          boughtCnt: _item?.cnt || 0
        })
      }
    })
    return moreList
  }, [storeMobx.viewStoreList, storeMobx.storeBoughtList])
  useEffect(() => {
    if (storeList.length === 1 && openChoose) onChange({ storeId: storeList[0].storeId, storeName: storeList[0].storeName })
  }, [storeList, openChoose])
  return (
    <>
      {
        openChoose ? (
          <>
            {
              storeList.length
                ? (
                  <div data-cypid='mmgChooseStore' className='mkt-choose-store' onClick={chooseStore}>
                    <span className='store-name'>{storeInfo.storeId ? storeInfo.storeName : i18n.t('store.choose_a_store')}</span>
                    {storeList.length > 1 && <i className='iconfont icon-chevron-down'></i>}
                  </div>
                ) : null
            }
          </>
        ) : ['cardRenew', 'cardRecharge', 'giftCard'].includes(scene) ? (
          <div className='mkt-choose-store'>
            <span className='store-name '>{i18n.t('mkt.member.rechargeOnline')}</span>
          </div>
        ) : ''
      }
    </>)
}

export default observer(ChooseStore)
